import integration from 'src/lib/api/integration';
import { getEnvironment } from 'src/lib/featureFlags';

const CONNECTION_ATTEMPTS = getEnvironment().logsMaxConnectionAttempts;

class LogsConnectionHandler {
  constructor({ onMessage, onStatusChange }) {
    this._onMessage = onMessage;
    this._onStatusChange = onStatusChange;
    this._connectedServiceInstances = [];
    this.connect()
      .catch(error => this._onStatusChange({ status: 'error', error }));
  }

  terminate() {
    this._onMessage = () => {};
    this._onStatusChange = () => {};
    this._connectedServiceInstances.forEach(s => s.terminate());
    this._connectedServiceInstances = [];
  }

  onError(error) {
    this._onStatusChange({ status: 'error', error });
    this.terminate();
  }

  async connect() {
    // prevent callback calls in the same stack
    await Promise.resolve();

    this._onStatusChange({ status: 'connecting', connectedServicesCount: 0 });
    const { id: accountsMappingId } = await integration.getAccountMapping();

    const all = await Promise.all(
      Array
        .from({ length: CONNECTION_ATTEMPTS })
        .map(() => integration.consumeLogs(accountsMappingId))
    );

    this._connectedServiceInstances = all
      .filter((s, index) => all.findIndex(ss => s.getInstanceId() === ss.getInstanceId()) === index);

    all
      .filter(s => !this._connectedServiceInstances.includes(s))
      .forEach(s => s.terminate());

    this._connectedServiceInstances.forEach(s => {
      s.onMessage(this._onMessage);
      s.onError(this.onError.bind(this));
    });

    this._onStatusChange({ status: 'connected', connectedServicesCount: this._connectedServiceInstances.length });
  }
}

export default LogsConnectionHandler;
